import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { TreeselectOptionProfile } from '@/views/Automation/CampaignCreatorV2/types';

interface Props {
  node: { raw: TreeselectOptionProfile };
  mode?: 'value' | 'option';
  labelClassName?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TreeselectProfileOption.ts',
  props: {
    node: null,
    mode: { default: 'option' },
    labelClassName: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true,CcIcon }
}

})